module.exports = __webpack_public_path__ + "img/qr-app-store.c2996d9d.svg";